import axios from 'axios'

import { SET_RUYI_STOCK_PRICE, SET_RUYI_STOCK_CHANGE, SET_RENOWN_STOCK_PRICE, SET_RENOWN_STOCK_CHANGE } from '@/store/mutation-types'

const ruyiStockApi = process.env.RUYI_STOCK_API
const renownStockApi = process.env.RENOWN_STOCK_API

export default {
  state: {
    ruyi: {
      price: 0.00,
      change: 0.00
    },
    renown: {
      price: 0.00,
      change: 0.00
    }
  },
  mutations: {
    [SET_RUYI_STOCK_PRICE] (state, price) {
      state.ruyi.price = price
    },
    [SET_RUYI_STOCK_CHANGE] (state, change) {
      state.ruyi.change = change
    },
    [SET_RENOWN_STOCK_PRICE] (state, price) {
      state.renown.price = price
    },
    [SET_RENOWN_STOCK_CHANGE] (state, change) {
      state.renown.change = change
    }
  },
  actions: {
    updateStocks ({ dispatch }) {
      dispatch('updateRuyiStock')
      dispatch('updateRenownStock')
    },
    async updateRuyiStock ({ commit }) {
      const { data } = await axios.get(ruyiStockApi)

      let price = parseFloat(data[0].stockPrice).toFixed(2)
      let change = data[0].changePercent.match(/(.*)%/)[1]
      if (!change) {
        change = '+0'
      }

      commit(SET_RUYI_STOCK_PRICE, price)
      commit(SET_RUYI_STOCK_CHANGE, change)
    },
    async updateRenownStock ({ commit }) {
      const { data } = await axios.get(renownStockApi)

      let price = parseFloat(data[0].stockPrice).toFixed(2)
      let change = data[0].change.match(/（(.*)%）/)[1]
      if (!change) {
        change = '+0'
      }

      commit(SET_RENOWN_STOCK_PRICE, price)
      commit(SET_RENOWN_STOCK_CHANGE, change)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/stocks.js